import Mustache from 'mustache'

import html from './Booking.html'
import Page from '../Page'

class Booking extends Page{
	id;
	reserva;
	
	html() { 
        return Mustache.render(html, {
			SaleId: this.reserva.SaleId,
			FullName: this.reserva.Name + ' ' + this.reserva.Surname,
			Product: this.reserva.Product,
			Hora: this.reserva.hora,
			Pista: this.reserva.pista,
			Email: this.reserva.Email,
			Phone: this.reserva.Phone
		})
	}

	constructor ( reserva ){
		super()
		this.reserva= reserva
		console.dir( reserva )
	}

	// He enviado el html y ahora quiero actualizarlo.
	update( ){
/*		_.dom.createTextNodes([
			{id: 'localizador', text: booking['localizador'] + '/' + booking['entradaReserva']}
			, {id: 'hora', text: booking['hora']}
			, {id: 'sesion', text: cfg.sesiones[booking['sesion']].name}
			, {id: 'recurso', text: cfg.recursos[booking['recursoAsignado']].caption}
			, {id: 'nombre', text: booking['nombreCliente']}
			, {id: 'email', text: booking['emailCliente']}
			, {id: 'telefono', text: booking['telefonoCliente']}
		])
*/
	}
}

export default Booking
